import { render, staticRenderFns } from "./MediaType.vue?vue&type=template&id=9ed4d88e&scoped=true&"
import script from "./MediaType.vue?vue&type=script&lang=js&"
export * from "./MediaType.vue?vue&type=script&lang=js&"
import style0 from "./MediaType.vue?vue&type=style&index=0&id=9ed4d88e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ed4d88e",
  null
  
)

export default component.exports